"use client";

import { MenuItem } from "./menuConfig";

export const getLocaleFromPathname = (pathname: string): string => {
  return pathname.split("/")[1] || "pt-BR";
};

export const isPathActive = (
  path: string | undefined,
  pathname: string,
  locale: string,
): boolean => {
  if (!path) return false;

  if (path === "/") {
    return pathname === `/${locale}` || pathname === `/${locale}/`;
  }

  return pathname === `/${locale}${path}`;
};

export const getLocalizedPath = (path: string, locale: string): string => {
  if (path.startsWith(`/${locale}`)) return path;

  if (path === "/") {
    return `/${locale}`;
  }

  return `/${locale}${path}`;
};

export const getInitialExpandedCategory = (
  navItems: MenuItem[],
  isActive: (path: string | undefined) => boolean,
): string[] => {
  const category = navItems.find((item) =>
    item.subItems?.some((sub) => isActive(sub.path)),
  );

  return category ? [category.id] : [];
};

export const isCategoryExpanded = (
  categoryId: string,
  expandedCategories: string[],
  item: MenuItem,
  isActive: (path: string | undefined) => boolean,
): boolean => {
  return (
    expandedCategories.includes(categoryId) ||
    item.subItems?.some((subItem) => isActive(subItem.path)) ||
    false
  );
};

export const getEstablishmentStatus = (session: any): string | undefined => {
  return (
    session?.user?.user?.establishment?.status ||
    session?.user?.establishment?.status
  );
};

export const isEstablishmentActive = (status: string | undefined): boolean => {
  return status === "active";
};
